import React from "react";
import { Container } from "reactstrap";
import CreateFormInput from "../CreateFormInput";
import { colors } from "../../Utils/Colors";
import { serverUrls } from "../../Utils/Urls";
import {
  getDisorderAndTreatment,
  getDisorderAndTreatmentSuccess,
  getDisorderAndTreatmentFailure,
  resetDisorderTreatmentState
} from "../../Actions/patientAction";
import { connect } from "react-redux";
import axios from "axios";

const formInputs = {
  disorder: {
    type: "select",
    placeholder: "disorder",
    values: {
      "None": "0",
      "Sclerotic bone diasease/ Non sclerotic bone disease": "1",
      "Osteogenesis Imperfecta": "2",
      "Fibrous dysplasia": "3",
      "Pagets disease": "4",
      "Tumor induced osteomalacia": "5",
      "Pyknodysostosis": "6",
      "CED": "7",
      'Scleroteosis': "8",
      "Juvenile osteoporosis": "9",
      "Syndromic Diagnosis": "10",
      "Atypical Femoral Fracture": "11",
      "Osteoprosis": "12",
      "T2D with Osteoporosis": "13",
      "Any Other": "14",
    },
    label: "Disorder",
  },
  remarks: {
    type: "text",
    placeholder: "Remarks",
    label: "Remarks",
  },
  treatment: {
    type: "text",
    placeholder: "treatment",
    label: "Treatment",
  },
};

class DisorderAndTreatment extends React.Component {
  componentDidMount() {
    this.props.getDisorderAndTreatmentEdit(
      serverUrls.disorderandtreatment + this.props.id + "/"
    );
  }
  componentWillUnmount() {
    this.props.resetDisorderTreatmentState();
  }
  render() {
    var url = serverUrls.disorderandtreatment + this.props.id + "/";
    return (
      <Container style={{ maxWidth: 800, background: colors.lightGrey }}>
        <br />
        <h4>Disorder And Treatment</h4>
        <br />
        <CreateFormInput
          isPost={false}
          buttonName="Save"
          url={url}
          formName="getDisorderAndTreatment"
          inputs={formInputs}
          remarks={this.props.remarks}
          treatment={this.props.treatment}
        />
        <br />
        <br />
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    remarks: state.getDisorderAndTreatment.remarks,
    treatment: state.getDisorderAndTreatment.treatment,
  };
  
};


const mapDispatchToProps = (dispatch) => {
  return {
    getDisorderAndTreatmentEdit: (url) => {
      dispatch(getDisorderAndTreatment({ loading: true }));
      axios
        .get(url)
        .then((res) => {
          dispatch(
            getDisorderAndTreatmentSuccess({
              loading: false,
              success: res.data.success,
              data: res.data,
            })
          );
        })
        .catch((err) => {
          dispatch(getDisorderAndTreatmentFailure({ loading: false }));
        });
    },
    resetDisorderTreatmentState: () => {
      dispatch(resetDisorderTreatmentState());
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DisorderAndTreatment);
